var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestServiceBase, RestResult } from '@ane/core/lib/services/RestServiceBase';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import { WPSProxyConverter } from '@ane/core/lib/services/WPSProxy';
import { toBeDeletedSegment } from '../common/utils/MDLComputations.utils';
import { v4 } from 'uuid';
let VivaceResoures = class VivaceResoures extends RestServiceBase {
    constructor() {
        super(EnvironmentService.endpoints.metricService, '/api');
    }
    getMetricSetDrafts(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts`;
            const result = yield this._get(address);
            return result;
        });
    }
    getMetricSetDraftMetadata(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/Metadata`;
            const result = yield this._get(address);
            return result;
        });
    }
    createMetricSet(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, experimentationGroup, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/experimentationgroups/${experimentationGroup}?isDSMSOverridesFeatureEnabled=true`;
            return yield this._post(null, address);
        });
    }
    cloneMetricSet(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, sourceMetricSetName, experimentationGroup, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/experimentationgroups/${experimentationGroup}?sourceMetricSet=${sourceMetricSetName}`;
            return yield this._post(null, address);
        });
    }
    getMetricSetHistory(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/history`;
            const result = yield this._get(address);
            return result;
        });
    }
    deleteMetricSet(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}`;
            return yield this._delete(address);
        });
    }
    createDraft(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}`;
            return yield this._post(null, address);
        });
    }
    deleteDraft(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}`;
            return yield this._delete(address);
        });
    }
    mergeMetricSetDraft(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/mergeRequest`;
            return yield this._post(null, address);
        });
    }
    updateMergeStatus(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, mergeStatus, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/mergeStatus`;
            return yield this._post(mergeStatus, address);
        });
    }
    getExperimentationGroups(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const address = !!payload.metricWrite && payload.metricWrite
                ? `/workspaces/${payload.workspaceId}/experimentationGroups?permission=MetricWrite`
                : `/workspaces/${payload.workspaceId}/experimentationGroups`;
            return yield this._get(address);
        });
    }
    getMetricSetDraftRawColumns(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/RawColumns`;
            const result = yield this._get(address);
            return result;
        });
    }
    getMetricSetDraftAggregationLevels(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/MdlTables`;
            const result = yield this._get(address);
            return result;
        });
    }
    getMetricSetDraftExperimentationConfig(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/ExperimentationConfig`;
            const result = yield this._get(address);
            return result;
        });
    }
    getScorecardLayouts(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/ScorecardLayouts`;
            const result = yield this._get(address);
            return result;
        });
    }
    getComputationTemplates(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/Computations/ComputationTemplate`;
            const result = yield this._get(address);
            return result;
        });
    }
    getComputationTemplateInstances(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, templateName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/computationTemplates/${templateName}/instances`;
            const result = yield this._get(address);
            return result;
        });
    }
    getMetricsForTemplateInstance(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, templateName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/computationTemplates/${templateName}/computations/Metric`;
            const result = yield this._get(address);
            return result;
        });
    }
    getScorecardLayoutFilePaths(_a) {
        return __awaiter(this, arguments, void 0, function* ({ metricSetName, draftName, metricName, workspaceId, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/metricsInScorecards?metricName=${metricName}`;
            const result = yield this._get(address);
            return result;
        });
    }
    getScorecardLayoutFile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ metricSetName, draftName, filePath, workspaceId, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/ScorecardLayouts/${filePath}`;
            const result = yield this._get(address);
            return result;
        });
    }
    putScorecardLayoutFile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ metricSetName, draftName, filePath, scorecardLayoutFile, workspaceId, }) {
            const path = `/workspaces/${workspaceId}/metricsets/${metricSetName}/drafts/${draftName}/ScorecardLayouts/${filePath}`;
            const result = yield this._put(scorecardLayoutFile, path);
            return result;
        });
    }
    getUserMetricWriteAccess(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/userAccess/MetricWrite?draft=${draftName}`;
            const result = yield this._get(address);
            if (result.statusCode === 403 || result.statusCode === 404) {
                return RestResult.fromResult(false, true);
            }
            else if (result.statusCode === 200) {
                return RestResult.fromResult(true, true);
            }
            // @ts-ignore
            return result;
        });
    }
    getWorkspaceConfig(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId }) {
            const address = `/workspaces/${workspaceId}/config`;
            const result = yield this._get(address);
            return result;
        });
    }
    getMetricSetConfig(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/config`;
            const result = yield this._get(address);
            return result;
        });
    }
    putMetricSetConfig(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, request, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${request.metricSet}/config`;
            const result = yield this._put(request, address);
            return result;
        });
    }
    postMetricSetInstance(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, request, }) {
            const address = `/workspaces/${workspaceId}/metricsetinstance`;
            const result = yield this._post(request, address);
            return result;
        });
    }
    getMetricSetInstanceCreateStatus(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, operationId, }) {
            const address = `/workspaces/${workspaceId}/metricsetinstance/${metricSetName}/${operationId}`;
            const result = yield this._get(address);
            return result;
        });
    }
    validateMetricSetDraft(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/build`;
            const result = yield this._post(null, address);
            return result;
        });
    }
    getValidationResult(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, requestId, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/build/${requestId}`;
            return yield this._get(address);
        });
    }
    getHealthCheck(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, metricHealthCheck, lookBackWeeks, lookBackWeeksUntil, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/metricHealthChecks/${metricHealthCheck}?lookBackWeeks=${lookBackWeeks}&lookBackUntilWeeks=${lookBackWeeksUntil}`;
            const result = yield this._get(address);
            return result;
        });
    }
    publishMetricSetDraft(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/publish`;
            const result = yield this._post(null, address);
            return result;
        });
    }
    getPublishStatus(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/publishOperation`;
            return yield this._get(address);
        });
    }
    updatePublishStatus(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, draftName, publishStatus, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/publishStatus`;
            return yield this._post(publishStatus, address);
        });
    }
    getPublishedVersions(_a) {
        return __awaiter(this, arguments, void 0, function* ({ workspaceId, metricSetName, isDraft, }) {
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/list-metadata?isDraft=${isDraft}`;
            return yield this._get(address);
        });
    }
    getAllComputationsByType(_a) {
        return __awaiter(this, arguments, void 0, function* ({ metricSetName, draftName, computationType, offset, workspaceId, prefix, }) {
            const path = `/workspaces/${workspaceId}/metricsets/${encodeURIComponent(metricSetName)}/drafts/${draftName}/Computations/${computationType}?offset=${offset}${prefix ? '&partialName=' + prefix : ''}`;
            const result = yield this._get(path);
            return result;
        });
    }
    getMDLComputationFiles(_a) {
        return __awaiter(this, arguments, void 0, function* ({ metricSetName, draftName, workspaceId, }) {
            const path = `/workspaces/${workspaceId}/metricsets/${encodeURIComponent(metricSetName)}/drafts/${draftName}/MdlComputations`;
            const result = yield this._get(path);
            return result;
        });
    }
    getMDLComputationFile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ metricSetName, draftName, computationFileName, workspaceId, }) {
            const path = `/workspaces/${workspaceId}/metricsets/${encodeURIComponent(metricSetName)}/drafts/${draftName}/MdlComputations/${computationFileName}`;
            const result = yield this._get(path);
            return result;
        });
    }
    putMDLComputationFile(_a) {
        return __awaiter(this, arguments, void 0, function* ({ metricSetName, draftName, computationFileName, workspaceId, request, }) {
            const path = `/workspaces/${workspaceId}/metricsets/${encodeURIComponent(metricSetName)}/drafts/${draftName}/MdlComputations/${computationFileName}`;
            const result = yield this._put(request, path);
            return result;
        });
    }
    deleteSegments(_a) {
        return __awaiter(this, arguments, void 0, function* ({ metricSetName, draftName, workspaceId, segmentsToDelete, computationFileName, }) {
            const mdlComputationFile = yield this.getMDLComputationFile({
                metricSetName,
                draftName,
                workspaceId,
                computationFileName: computationFileName,
            });
            const mdlComputations = mdlComputationFile.getSuccessData();
            const computations = mdlComputations.Mdl;
            const filteredComputations = computations.Computations.i.filter((f) => !toBeDeletedSegment(segmentsToDelete, f));
            mdlComputations.Mdl.Computations.i = filteredComputations;
            return yield this.putMDLComputationFile({
                metricSetName,
                draftName,
                workspaceId,
                computationFileName: computationFileName,
                request: mdlComputations,
            });
        });
    }
    getMetric(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { workspaceId, metricSetName, draftName, metricInternalName } = payload;
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/Computations/Metric?count=1&offset=0&partialName=${metricInternalName}&exactMatch=true`;
            const result = yield this._get(address);
            return result;
        });
    }
    checkIfNeedQuickValidation(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { workspaceId, metricSetName, draftName } = payload;
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/draft/${draftName}/quick-validation-check?requestId=${v4()}`;
            const result = yield this._get(address);
            return result;
        });
    }
    quickCompute(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { workspaceId, metricSetName, draftName, request, requestId } = payload;
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/draft/${draftName}/quick-compute?requestId=${requestId}`;
            const result = yield this._put(request, address);
            return result;
        });
    }
    quickCompile(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { workspaceId, metricSetName, draftName, request, requestId } = payload;
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/draft/${draftName}/quick-compile?requestId=${requestId}`;
            const result = yield this._put(request, address);
            return result;
        });
    }
    getQuickValidationResult(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { workspaceId, metricSetName, draftName, metricNameList } = payload;
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/draft/${draftName}/quick-validation-result?metricNameList=${metricNameList}`;
            const result = yield this._get(address);
            return result;
        });
    }
    cancelQuickCompute(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { workspaceId, metricSetName, draftName, metricNameList } = payload;
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/draft/${draftName}/quick-compute/cancel?metricNameList=${metricNameList}`;
            const result = yield this._post(null, address);
            return result;
        });
    }
    getDataSourceForDraft(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { workspaceId, metricSetName, draftName } = payload;
            const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/drafts/${draftName}/DataSource/`;
            const result = yield this._get(address);
            return result;
        });
    }
    getDataSourceDetails(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const { workspaceId, dataSourceName } = payload;
            const address = `/workspaces/${workspaceId}/DataSource/${dataSourceName}`;
            const result = yield this._get(address);
            return result;
        });
    }
};
VivaceResoures = __decorate([
    WPSProxyConverter()
], VivaceResoures);
export { VivaceResoures };
export default new VivaceResoures();

//# sourceMappingURL=VivaceResoures.js.map
